import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import './Navbar.css'

const Navbar = () => {
const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  return (
    <div data-role="Header" className="navbar-cont">
        <div className="navbar-row">
          <div className="nav-elements">
            <img
              alt="logo"
              src="/assets/LogoWhite.svg"
              className="arena-nav-logo"
            />

            <div className="navlinks-cont">
              <NavLink exact to="/" className="navlink">
                Home
              </NavLink>

              <NavLink to="/rules" className="navlink">
                Regolamento
              </NavLink>

              <NavLink to="/subscribe" className="navlink">
                Iscriviti
              </NavLink>

              <NavLink to="/aboutUs" className="navlink">
                Chi siamo
              </NavLink>
              </div>
          </div>
          <div className="right-nav-cont">
            <button
                type="button"
                aria-label="Apri menu"
                className="burger-menu"
                onClick={() => setIsMobileMenuOpen(true)}
              >
                <svg viewBox="0 0 1024 1024" className="menu-icon">
                  <path d="M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"></path>
                </svg>
              </button>
          </div>

          {isMobileMenuOpen && (
            <div className="home-menu-overlay is-open" onClick={() => setIsMobileMenuOpen(false)}/>
          )}

          <div data-role="MobileMenu" className={`mobile-menu ${isMobileMenuOpen ? 'is-open' : ''}`}>
            <div className="home-container2">
              <img
                alt="logo"
                src="/assets/LogoWhite.svg"
                className="arena-nav-logo"
              />
              <button
                type="button"
                aria-label="Chiudi menu"
                className="close-menu"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <svg viewBox="0 0 1024 1024" className="home-icon12">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </button>
            </div>

            <div className="nav-links-mobile-cont">
              <NavLink exact to="/" className="navlink">
                Home
              </NavLink>

              <NavLink to="/rules" className="navlink">
                Regolamento
              </NavLink>

              <NavLink to="/subscribe" className="navlink">
                Iscriviti
              </NavLink>

              <NavLink to="/aboutUs" className="navlink">
                Chi siamo
              </NavLink>
            </div>
            <img src="assets/sagoma(3).png"/>
          </div>
        </div>
      </div>
  )
}

export default Navbar
